/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/258-crying': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13z"/><path pid="1" d="M12.5 6h-2a.5.5 0 010-1h2a.5.5 0 010 1zM5.5 6h-2a.5.5 0 010-1h2a.5.5 0 010 1zM9.5 13.375a.502.502 0 01-.354-.146C9.074 13.157 8.686 13 8 13s-1.075.157-1.146.229a.5.5 0 01-.707-.707c.471-.471 1.453-.521 1.854-.521s1.383.051 1.854.521a.5.5 0 01-.354.853zM11.5 9a.5.5 0 01-.5-.5v-1a.5.5 0 011 0v1a.5.5 0 01-.5.5zM11.5 12a.5.5 0 01-.5-.5v-1a.5.5 0 011 0v1a.5.5 0 01-.5.5zM4.5 9a.5.5 0 01-.5-.5v-1a.5.5 0 011 0v1a.5.5 0 01-.5.5zM4.5 12a.5.5 0 01-.5-.5v-1a.5.5 0 011 0v1a.5.5 0 01-.5.5z"/>'
  }
})
